<script>
export default {
  data() {
    return {};
  },
};
</script>
